// ============================================================
// HABIT OS — Rechtliche Seiten (Impressum, Datenschutzerklärung)
// Texte kommen aus src/data/legal.js.
// ============================================================

import React from "react";
import { IMPRESSUM, DATENSCHUTZ, LEGAL_STAND, LEGAL_GEPRUEFT } from "../data/legal";

// **fett**, `code` und – nach der Prüfung – ohne [offene Punkte]
function inline(text, Z) {
  const clean = LEGAL_GEPRUEFT ? text.replace(/\s*\[[^\]]*\]/g, "") : text;
  return clean.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).filter(Boolean).map((part, i) => {
    if (part.startsWith("**")) return <strong key={i} style={{ color: Z.onSurface, fontWeight: 600 }}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("`"))  return <code key={i} style={{ fontSize: "0.92em", background: Z.surfaceContainer, padding: "1px 5px", borderRadius: 4 }}>{part.slice(1, -1)}</code>;
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

function Block({ b, Z, p, h }) {
  if (b.t === "h")  return <h4 style={h}>{b.text}</h4>;
  if (b.t === "ul") return (
    <ul style={{ ...p, paddingLeft: 18 }}>
      {b.items.map((it, i) => <li key={i} style={{ marginBottom: 4 }}>{inline(it, Z)}</li>)}
    </ul>
  );
  return <p style={{ ...p, whiteSpace: "pre-line" }}>{inline(b.text, Z)}</p>;
}

export function LegalSheet({ Z, kind, onClose }) {
  const doc  = kind === "impressum" ? IMPRESSUM : DATENSCHUTZ;
  const font = "'Plus Jakarta Sans', sans-serif";
  const h = { fontFamily: "'Manrope', sans-serif", fontSize: 15, fontWeight: 600, color: Z.onSurface, margin: "20px 0 8px" };
  const p = { fontSize: 13, color: Z.onSurfaceVariant, lineHeight: 1.6, margin: "0 0 8px", fontFamily: font };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(25,28,24,0.6)", zIndex: 1000, display: "flex", alignItems: "flex-end" }} onClick={onClose}>
      <div role="dialog" aria-label={doc.titel} style={{ background: Z.surface, width: "100%", maxHeight: "92vh", borderRadius: "24px 24px 0 0", display: "flex", flexDirection: "column", overflow: "hidden" }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 16px 8px", flexShrink: 0 }}>
          <div style={{ width: 32 }} />
          <div style={{ width: 36, height: 4, borderRadius: 2, background: Z.outlineVariant }} />
          <button onClick={onClose} aria-label="Schließen" style={{ width: 32, height: 32, borderRadius: "50%", border: "none", background: Z.surfaceContainerHigh || Z.surfaceContainer, color: Z.onSurfaceVariant, fontSize: 16, cursor: "pointer" }}>✕</button>
        </div>

        <div style={{ overflowY: "auto", padding: "0 20px 40px", WebkitOverflowScrolling: "touch" }}>
          <h3 style={{ fontFamily: "'Manrope', sans-serif", fontSize: 18, fontWeight: 500, color: Z.onSurface, margin: "0 0 4px" }}>{doc.titel}</h3>
          <p style={{ ...p, fontSize: 12 }}>Stand: {LEGAL_STAND}</p>

          {!LEGAL_GEPRUEFT && (
            <div style={{ background: Z.errorContainer || "#ffdad6", color: Z.error || "#ba1a1a", borderRadius: 12, padding: "10px 12px", fontSize: 12, lineHeight: 1.5, margin: "8px 0 4px", fontFamily: font }}>
              Entwurf: Dieser Text ist noch in rechtlicher Prüfung. Stellen in [eckigen Klammern] sind offen.
            </div>
          )}

          {kind === "impressum"
            ? IMPRESSUM.bloecke.map((b, i) => <Block key={i} b={b} Z={Z} p={p} h={h} />)
            : DATENSCHUTZ.abschnitte.map((s, i) => (
                <section key={i}>
                  <h4 style={h}>{i + 1}. {s.titel}</h4>
                  {s.bloecke.map((b, j) => <Block key={j} b={b} Z={Z} p={p} h={h} />)}
                </section>
              ))}
        </div>
      </div>
    </div>
  );
}
